(() => {
  'use strict';

  const money = (amount, currency = 'INR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency, maximumFractionDigits: 0,
      }).format(Number(amount || 0) / 100);
    } catch (_error) {
      return `Rs. ${(Number(amount || 0) / 100).toLocaleString('en-IN')}`;
    }
  };



  const showCartToast = (message, isError = false) => {
    let toast = document.querySelector('[data-ani-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ani-ref-cart-toast';
      toast.dataset.aniCartToast = 'true';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('is-error', Boolean(isError));
    toast.innerHTML = `<span>${message}</span>${isError ? '' : '<a href="/cart">View cart</a>'}`;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._aniTimer);
    toast._aniTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  const updateHeaderCartCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.ani-ref-header__cart').forEach((link) => {
        link.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
        let badge = link.querySelector('b');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('b');
            link.appendChild(badge);
          }
          badge.textContent = String(cart.item_count);
        } else badge?.remove();
      });
      return cart;
    } catch (_error) { return undefined; }
  };

  const ajaxAddForm = async (form, statusNode, button) => {
    if (!form || form.dataset.aniAdding === 'true') return false;
    form.dataset.aniAdding = 'true';
    if (button) button.disabled = true;
    if (statusNode) {
      statusNode.hidden = false;
      statusNode.classList.remove('is-error', 'is-success');
      statusNode.textContent = 'Adding to your cart...';
    }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'This item could not be added to the cart.');
      await updateHeaderCartCount();
      const productName = payload.product_title || payload.title || 'Product';
      if (statusNode) {
        statusNode.hidden = false;
        statusNode.classList.add('is-success');
        statusNode.textContent = `${productName} added to cart. You can keep shopping or open the cart when ready.`;
      }
      showCartToast('Added to cart successfully.');
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'ani-reference' } }));
      return true;
    } catch (error) {
      const message = error?.message || 'Unable to add this item. Please try again.';
      if (statusNode) {
        statusNode.hidden = false;
        statusNode.classList.add('is-error');
        statusNode.textContent = message;
      }
      showCartToast(message, true);
      return false;
    } finally {
      delete form.dataset.aniAdding;
      if (button) button.disabled = false;
    }
  };

  const initHeader = () => {
    document.querySelectorAll('[data-ani-ref-mobile-menu]').forEach((menu) => {
      if (menu.dataset.ready === 'true') return;
      menu.dataset.ready = 'true';
      menu.querySelector('[data-ani-ref-menu-close]')?.addEventListener('click', () => menu.removeAttribute('open'));
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
    });

    document.querySelectorAll('[data-ani-header-ticker]').forEach((ticker) => {
      if (ticker.dataset.closeReady === 'true') return;
      ticker.dataset.closeReady = 'true';
      const storageKey = 'aniAnnouncementDismissed';
      try {
        if (!window.Shopify?.designMode && window.sessionStorage?.getItem(storageKey) === '1') ticker.hidden = true;
      } catch (_error) { /* Storage may be blocked. */ }
      ticker.querySelector('[data-ani-ticker-close]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        ticker.hidden = true;
        try {
          if (!window.Shopify?.designMode) window.sessionStorage?.setItem(storageKey, '1');
        } catch (_error) { /* Storage may be blocked. */ }
      });
    });
  };

  const initSort = () => {
    document.querySelectorAll('[data-ani-ref-sort]').forEach((select) => {
      if (select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const form = select.form;
        if (!form) return;
        const activeUrl = new URL(window.location.href);
        const existingPairs = new Set(
          [...form.querySelectorAll('input[name]')].map((input) => `${input.name}\u0000${input.value}`)
        );
        activeUrl.searchParams.forEach((value, name) => {
          if (!name.startsWith('filter.')) return;
          const pair = `${name}\u0000${value}`;
          if (existingPairs.has(pair)) return;
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = name;
          hidden.value = value;
          form.appendChild(hidden);
          existingPairs.add(pair);
        });
        form.submit();
      });
    });
  };

  const updateWhatsapp = (anchor) => {
    const wrapper = anchor.closest('.ani-luxe-product-whatsapp');
    const root = anchor.closest('[data-ani-product-root]') || document;
    const form = root.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const variantId = variantInput?.value;
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    let variants = [];
    try { variants = JSON.parse(wrapper?.querySelector('[data-ani-luxe-product-variants]')?.textContent || '[]'); } catch (_error) { variants = []; }
    const variant = variants.find((item) => String(item.id) === String(variantId)) || variants[0];
    const currency = anchor.dataset.currency || root.dataset.currency || window.Shopify?.currency?.active || 'INR';
    const title = anchor.dataset.productTitle || document.title;
    const variantTitle = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
    const price = variant ? money(variant.price, currency) : (root.querySelector('[data-ani-product-price]')?.textContent?.trim() || 'Please confirm');
    const shopUrl = anchor.dataset.shopUrl || (window.location.origin === 'null' ? '' : window.location.origin);
    const productPath = anchor.dataset.productPath || window.location.pathname;
    const productUrl = `${shopUrl}${productPath}${variantId ? `?variant=${encodeURIComponent(variantId)}` : ''}`;
    const lines = ['Hello ANI Fashion Jewellery,', '', 'I am interested in this product:', `Product: ${title}`];
    if (variantTitle) lines.push(`Variant: ${variantTitle}`);
    lines.push(`Price: ${price}`, `Quantity: ${quantity}`, `Product link: ${productUrl}`, '', 'Please confirm availability, delivery time and the next steps.');
    anchor.href = `https://wa.me/${anchor.dataset.whatsappPhone}?text=${encodeURIComponent(lines.join('\n'))}`;
  };

  const initFallbackCollectionFilters = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-ani-fallback-filter]').forEach((input) => {
      if (input.dataset.fallbackReady === 'true') return;
      input.dataset.fallbackReady = 'true';
      if (!input.name) return;
      if (input.type === 'checkbox') {
        input.checked = params.getAll(input.name).includes(input.value);
      } else {
        const value = params.get(input.name);
        if (value !== null && value !== '') input.value = value;
      }
    });
  };

  const initPriceFilters = () => {
    document.querySelectorAll('[data-ani-price-filter]').forEach((group) => {
      if (group.dataset.ready === 'true') return;
      group.dataset.ready = 'true';
      const minInput = group.querySelector('[data-ani-price-min]');
      const maxInput = group.querySelector('[data-ani-price-max]');
      const rangeMax = Number(group.dataset.rangeMax || maxInput?.max || 0);

      const clamp = (value) => {
        if (!Number.isFinite(value)) return null;
        return Math.min(Math.max(value, 0), Number.isFinite(rangeMax) && rangeMax > 0 ? rangeMax : value);
      };

      const normalize = (changed) => {
        let min = minInput?.value === '' ? null : clamp(Number(minInput?.value));
        let max = maxInput?.value === '' ? null : clamp(Number(maxInput?.value));

        if (min !== null && max !== null && min > max) {
          if (changed === maxInput) min = max;
          else max = min;
        }
        if (minInput && min !== null) minInput.value = String(min);
        if (maxInput && max !== null) maxInput.value = String(max);
      };

      [minInput, maxInput].forEach((input) => {
        input?.addEventListener('change', () => normalize(input));
        input?.addEventListener('blur', () => normalize(input));
        input?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          normalize(input);
          input.form?.requestSubmit?.();
        });
      });
      group.closest('form')?.addEventListener('submit', () => normalize(null));
      normalize(null);
    });
  };

  const initProduct = () => {
    document.querySelectorAll('[data-ani-product-root]').forEach((root) => {
      if (root.dataset.aniRefReady === 'true') return;
      root.dataset.aniRefReady = 'true';

      let variants = [];
      let quantityRules = [];
      try { variants = JSON.parse(root.querySelector('[data-ani-product-variants]')?.textContent || '[]'); } catch (_error) { variants = []; }
      try { quantityRules = JSON.parse(root.querySelector('[data-ani-quantity-rules]')?.textContent || '[]'); } catch (_error) { quantityRules = []; }
      const form = root.querySelector('form[action*="/cart/add"]');
      const variantInput = form?.querySelector('[data-ani-variant-id], input[name="id"]');
      const optionGroups = [...root.querySelectorAll('[data-ani-option-group]')].sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0));
      const price = root.querySelector('[data-ani-product-price]');
      const compare = root.querySelector('[data-ani-product-compare]');
      const saving = root.querySelector('[data-ani-product-saving]');
      const availability = root.querySelector('[data-ani-product-availability]');
      const availabilityText = root.querySelector('[data-ani-availability-text]');
      const addButton = root.querySelector('[data-ani-add-to-cart]');
      const addLabel = root.querySelector('[data-ani-add-label]');
      const sku = root.querySelector('[data-ani-product-sku]');
      const variantTitleNode = root.querySelector('[data-ani-selected-variant-title]');
      const currency = root.dataset.currency || window.Shopify?.currency?.active || 'INR';
      const slides = [...root.querySelectorAll('[data-ani-product-media]')];
      const thumbs = [...root.querySelectorAll('[data-ani-media-target]')];

      const showMedia = (mediaId, fallback = 0) => {
        if (!slides.length) return;
        let index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index < 0) index = Math.min(Math.max(fallback, 0), slides.length - 1);
        slides.forEach((slide, position) => {
          slide.hidden = position !== index;
          if (position !== index) slide.querySelectorAll('video').forEach((video) => video.pause?.());
        });
        thumbs.forEach((thumb, position) => thumb.setAttribute('aria-current', position === index ? 'true' : 'false'));
        thumbs[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(thumb.dataset.aniMediaTarget, index)));
      const activeIndex = () => Math.max(0, slides.findIndex((slide) => !slide.hidden));
      root.querySelector('[data-ani-gallery-previous]')?.addEventListener('click', () => {
        const index = (activeIndex() - 1 + slides.length) % slides.length;
        showMedia(slides[index]?.dataset.mediaId, index);
      });
      root.querySelector('[data-ani-gallery-next]')?.addEventListener('click', () => {
        const index = (activeIndex() + 1) % slides.length;
        showMedia(slides[index]?.dataset.mediaId, index);
      });

      const quantity = root.querySelector('[data-ani-quantity-input]');
      const quantityMinus = root.querySelector('[data-ani-quantity-minus]');
      const quantityPlus = root.querySelector('[data-ani-quantity-plus]');

      const numberOr = (value, fallback) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const quantityRuleFor = (variant) => {
        const rule = quantityRules.find((item) => String(item.id) === String(variant?.id));
        return {
          min: Math.max(1, numberOr(rule?.min ?? variant?.quantity_rule?.min, 1)),
          max: (() => {
            const raw = rule?.max ?? variant?.quantity_rule?.max;
            if (raw === null || raw === undefined || raw === '') return null;
            const parsed = Number(raw);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
          })(),
          increment: Math.max(1, numberOr(rule?.increment ?? variant?.quantity_rule?.increment, 1)),
        };
      };

      const normalizeQuantity = (variant = selectedVariant(), emit = false) => {
        if (!quantity) return;
        const rule = quantityRuleFor(variant);
        quantity.min = String(rule.min);
        quantity.step = String(rule.increment);
        if (rule.max !== null) quantity.max = String(rule.max);
        else quantity.removeAttribute('max');

        let value = numberOr(quantity.value, rule.min);
        value = Math.max(value, rule.min);
        if (rule.max !== null) value = Math.min(value, rule.max);

        const offset = value - rule.min;
        if (offset > 0 && rule.increment > 1) {
          value = rule.min + Math.round(offset / rule.increment) * rule.increment;
          if (rule.max !== null) value = Math.min(value, rule.max);
        }
        quantity.value = String(value);
        if (quantityMinus) quantityMinus.disabled = value <= rule.min;
        if (quantityPlus) quantityPlus.disabled = rule.max !== null && value >= rule.max;
        if (emit) {
          quantity.dispatchEvent(new Event('input', { bubbles: true }));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      quantityMinus?.addEventListener('click', () => {
        if (!quantity) return;
        const rule = quantityRuleFor(selectedVariant());
        const current = numberOr(quantity.value, rule.min);
        quantity.value = String(Math.max(rule.min, current - rule.increment));
        normalizeQuantity(selectedVariant(), true);
      });
      quantityPlus?.addEventListener('click', () => {
        if (!quantity) return;
        const rule = quantityRuleFor(selectedVariant());
        const current = numberOr(quantity.value, rule.min);
        const next = current + rule.increment;
        quantity.value = String(rule.max !== null ? Math.min(rule.max, next) : next);
        normalizeQuantity(selectedVariant(), true);
      });
      quantity?.addEventListener('change', () => normalizeQuantity(selectedVariant(), false));
      quantity?.addEventListener('blur', () => normalizeQuantity(selectedVariant(), false));

      const selectedVariant = () => {
        if (!variants.length) return undefined;
        if (!optionGroups.length) return variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0];
        const selectedOptions = optionGroups.map((group) => group.querySelector('[data-ani-option]:checked')?.value || '');
        return variants.find((variant) => Array.isArray(variant.options) && variant.options.length === selectedOptions.length && variant.options.every((option, index) => String(option) === String(selectedOptions[index])));
      };

      const updateVariant = () => {
        const variant = selectedVariant();
        optionGroups.forEach((group) => {
          const checked = group.querySelector('[data-ani-option]:checked');
          const legendStrong = group.querySelector('legend strong');
          if (legendStrong && checked) legendStrong.textContent = checked.value;
        });
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          if (availability) availability.dataset.available = 'false';
          if (availabilityText) availabilityText.textContent = 'Unavailable';
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (price) price.textContent = money(variant.price, currency);
        const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        if (compare) { compare.hidden = !hasCompare; compare.textContent = hasCompare ? money(variant.compare_at_price, currency) : ''; }
        if (saving) {
          saving.hidden = !hasCompare;
          saving.textContent = hasCompare ? `${Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price))}% off` : '';
        }
        const available = Boolean(variant.available);
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to Cart' : 'Sold Out';
        if (availability) availability.dataset.available = available ? 'true' : 'false';
        if (availabilityText) availabilityText.textContent = available ? 'In Stock' : 'Sold Out';
        if (sku) sku.textContent = variant.sku || '—';
        if (variantTitleNode) variantTitleNode.textContent = variant.title || 'Default Title';
        normalizeQuantity(variant, false);
        const mediaId = variant.featured_media?.id || variant.featured_image?.id;
        if (mediaId) showMedia(mediaId);
        const nextUrl = `${root.dataset.productUrl || window.location.pathname}?variant=${encodeURIComponent(variant.id)}`;
        if (!window.Shopify?.designMode && window.history?.replaceState && window.location.origin !== 'null') window.history.replaceState({}, '', nextUrl);
        root.dispatchEvent(new CustomEvent('variant:update', { bubbles: true, detail: { variant } }));
        document.dispatchEvent(new CustomEvent('variant:update', { detail: { variant } }));
      };
      optionGroups.forEach((group) => group.addEventListener('change', updateVariant));
      updateVariant();

      if (form && form.dataset.aniAjaxReady !== 'true') {
        form.dataset.aniAjaxReady = 'true';
        form.addEventListener('submit', async (event) => {
          const submitter = event.submitter;
          const isAddAction = !submitter || submitter.matches?.('[data-ani-add-to-cart]') || submitter.name === 'add';
          if (!isAddAction) return;
          event.preventDefault();
          const statusNode = root.querySelector('[data-ani-add-status]');
          await ajaxAddForm(form, statusNode, addButton);
        });
      }

      const whatsapp = root.querySelector('[data-ani-luxe-whatsapp][data-whatsapp-context="product"]');
      if (whatsapp) {
        const refresh = () => updateWhatsapp(whatsapp);
        ['pointerenter', 'focus', 'click'].forEach((eventName) => whatsapp.addEventListener(eventName, refresh));
        root.addEventListener('input', refresh);
        root.addEventListener('change', refresh);
        root.addEventListener('variant:update', refresh);
        refresh();
      }

      root.querySelector('[data-ani-ref-share]')?.addEventListener('click', async () => {
        const shareData = { title: document.title, text: root.querySelector('h1')?.textContent?.trim() || document.title, url: window.location.href };
        try {
          if (navigator.share) await navigator.share(shareData);
          else { await navigator.clipboard.writeText(window.location.href); window.alert('Product link copied.'); }
        } catch (_error) { /* User cancelled or browser denied. */ }
      });
    });
  };


  const initQuickAdd = () => {
    document.querySelectorAll('.ani-ref-quick-add-form').forEach((form) => {
      if (form.dataset.aniAjaxReady === 'true') return;
      form.dataset.aniAjaxReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = event.submitter || form.querySelector('button[type="submit"]');
        const previous = button?.textContent;
        if (button) button.textContent = 'Adding...';
        await ajaxAddForm(form, null, button);
        if (button && previous) button.textContent = previous;
      });
    });
  };

  const initCartPage = () => {
    document.querySelectorAll('[data-ani-cart-page-form]').forEach((form) => {
      if (form.dataset.aniCartReady === 'true') return;
      form.dataset.aniCartReady = 'true';
      const status = form.querySelector('[data-ani-cart-page-status]');
      const rootPath = window.Shopify?.routes?.root || '/';

      const setStatus = (message = '', isError = false) => {
        if (!status) return;
        status.hidden = !message;
        status.textContent = message;
        status.classList.toggle('is-error', Boolean(isError));
        status.classList.toggle('is-success', Boolean(message) && !isError);
      };

      const requestChange = async (payload) => {
        const response = await fetch(`${rootPath}cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));
        return { response, data };
      };

      form.querySelectorAll('[data-ani-cart-remove]').forEach((removeLink) => {
        removeLink.addEventListener('click', async (event) => {
          event.preventDefault();
          if (removeLink.dataset.aniRemoving === 'true') return;

          const lineKey = removeLink.dataset.lineKey || '';
          const line = Number.parseInt(removeLink.dataset.line || '', 10);
          const item = removeLink.closest('.ani-ref-cart-item');
          const originalText = removeLink.textContent;
          removeLink.dataset.aniRemoving = 'true';
          removeLink.setAttribute('aria-disabled', 'true');
          removeLink.textContent = 'Removing…';
          item?.setAttribute('aria-busy', 'true');
          setStatus('Removing item from your cart…');

          try {
            let result = lineKey ? await requestChange({ id: lineKey, quantity: 0 }) : await requestChange({ line, quantity: 0 });

            // A cart can change between render and click. If the key is stale, retry once by current line number.
            if (!result.response.ok && Number.isFinite(line) && line > 0 && lineKey) {
              result = await requestChange({ line, quantity: 0 });
            }

            if (!result.response.ok) {
              const message = result.data?.description || result.data?.message || result.data?.errors || 'We could not remove this item. Please refresh the page and try again.';
              throw new Error(typeof message === 'string' ? message : 'We could not remove this item. Please refresh the page and try again.');
            }

            await updateHeaderCartCount();
            setStatus('Item removed. Refreshing your cart…');
            item?.classList.add('is-removing');
            window.location.reload();
          } catch (error) {
            console.error('ANI cart remove error:', error);
            setStatus(error?.message || 'We could not remove this item. Please refresh the page and try again.', true);
            removeLink.textContent = originalText;
            removeLink.removeAttribute('aria-disabled');
            item?.removeAttribute('aria-busy');
            delete removeLink.dataset.aniRemoving;
          }
        });
      });
    });
  };

  const initTabs = () => {
    document.querySelectorAll('[data-ani-ref-tabs]').forEach((tabs) => {
      if (tabs.dataset.ready === 'true') return;
      tabs.dataset.ready = 'true';
      const buttons = [...tabs.querySelectorAll('[data-tab-target]')];
      const panels = [...tabs.querySelectorAll('[data-tab-panel]')];
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => item.setAttribute('aria-selected', item === button ? 'true' : 'false'));
        panels.forEach((panel) => { panel.hidden = panel.dataset.tabPanel !== button.dataset.tabTarget; });
      }));
    });
  };

  const initCarousels = () => {
    document.querySelectorAll('[data-ani-ref-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      const viewport = carousel.querySelector('[data-carousel-viewport]');
      if (!viewport) return;
      const scroll = (direction) => viewport.scrollBy({ left: direction * Math.max(viewport.clientWidth * 0.9, 280), behavior: 'smooth' });
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => scroll(-1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => scroll(1));
    });
  };

  const initReviewSliders = () => {
    document.querySelectorAll('[data-ani-review-slider]').forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const slides = [...slider.querySelectorAll('[data-ani-review-slide]')];
      const dots = [...slider.querySelectorAll('[data-ani-review-dot]')];
      if (!slides.length) return;
      let index = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      let timer;

      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, position) => { slide.hidden = position !== index; });
        dots.forEach((dot, position) => dot.setAttribute('aria-current', position === index ? 'true' : 'false'));
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (slides.length < 2 || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => show(index + 1), 6500);
      };

      slider.querySelector('[data-ani-review-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
      slider.querySelector('[data-ani-review-next]')?.addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.aniReviewDot || 0)); start(); }));
      slider.addEventListener('pointerenter', stop);
      slider.addEventListener('pointerleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      show(index);
      start();
    });
  };

  const initFaq = () => {
    document.querySelectorAll('[data-ani-ref-faq]').forEach((faq) => {
      if (faq.dataset.ready === 'true') return;
      faq.dataset.ready = 'true';
      const input = faq.querySelector('[data-ani-ref-faq-search]');
      const items = [...faq.querySelectorAll('[data-faq-item]')];
      const empty = faq.querySelector('[data-ani-ref-faq-empty]');
      const topics = [...faq.querySelectorAll('[data-faq-topic]')];
      const heading = faq.querySelector('[data-ani-ref-faq-heading]');
      const searchButton = faq.querySelector('.ani-ref-faq-search button');
      let category = '';
      const filter = () => {
        const query = (input?.value || '').trim().toLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const text = (item.dataset.faqSearchText || item.textContent || '').toLowerCase();
          const matchText = !query || text.includes(query);
          const matchCategory = !category || item.dataset.faqCategory === category;
          item.hidden = !(matchText && matchCategory);
          if (!item.hidden) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      };
      input?.addEventListener('input', filter);
      input?.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); filter(); } });
      searchButton?.addEventListener('click', () => { filter(); input?.focus(); });
      topics.forEach((topic) => topic.addEventListener('click', () => {
        category = topic.dataset.faqTopic || '';
        topics.forEach((item) => item.classList.toggle('is-active', item === topic));
        if (heading) heading.textContent = topic.querySelector('b')?.textContent || 'All Questions';
        filter();
      }));
      faq.querySelector('[data-ani-ref-faq-expand]')?.addEventListener('click', (event) => {
        const visible = items.filter((item) => !item.hidden);
        const openAll = visible.some((item) => !item.open);
        visible.forEach((item) => { item.open = openAll; });
        event.currentTarget.firstChild.textContent = openAll ? 'Collapse All ' : 'Expand All ';
      });
    });
  };

  const initCategorySelectors = () => {
    document.querySelectorAll('[data-ani-category-selector]').forEach((selector) => {
      if (selector.dataset.aniCategoryReady === 'true') return;
      selector.dataset.aniCategoryReady = 'true';
      selector.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', () => {
          const target = select.value;
          if (target) window.location.assign(target);
        });
      });
    });
  };

  const initDynamicCategoryGroups = () => {
    document.querySelectorAll('.ani-category-hierarchy__group').forEach((group) => {
      group.hidden = !group.querySelector('li');
    });
  };

  const initCollectionGroupFilters = () => {
    document.querySelectorAll('[data-ani-category-group-filters]').forEach((host) => {
      const section = host.closest('.ani-ref-filters__content') || host.parentElement;
      const parentSelect = section?.querySelector('[data-ani-category-parent]');
      const sourceRoot = section?.querySelector('[data-ani-category-group-sources]');
      if (!parentSelect || !sourceRoot) return;

      const normalizePath = (value) => {
        if (!value) return '';
        try { return new URL(value, window.location.origin).pathname.replace(/\/$/, ''); }
        catch (_) { return String(value).split('?')[0].replace(/\/$/, ''); }
      };
      const parentPath = normalizePath(parentSelect.value);
      const parentHandle = parentPath.split('/').filter(Boolean).pop() || '';
      const source = sourceRoot.querySelector(`[data-ani-category-source="${CSS.escape(parentHandle)}"]`);
      host.innerHTML = '';
      if (!source) return;

      const currentPath = normalizePath(host.dataset.currentCollectionUrl || window.location.pathname);
      const groups = [...source.querySelectorAll('.ani-category-hierarchy__group')];
      groups.forEach((group) => {
        const entries = [...group.querySelectorAll('li')];
        if (!entries.length) return;
        const heading = group.querySelector('h3')?.textContent?.trim() || 'Subcategory';

        const details = document.createElement('details');
        details.className = 'ani-ref-filter-accordion ani-ref-category-group-accordion';
        const summary = document.createElement('summary');
        const label = document.createElement('span');
        label.textContent = heading;
        const arrow = document.createElement('i');
        arrow.setAttribute('aria-hidden', 'true');
        summary.append(label, arrow);

        const content = document.createElement('div');
        content.className = 'ani-ref-filter-accordion__content';
        const select = document.createElement('select');
        select.className = 'ani-ref-category-group-select';
        select.setAttribute('aria-label', heading);

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select option';
        select.appendChild(placeholder);

        let hasCurrent = false;
        const seen = new Set();
        entries.forEach((entry) => {
          const link = entry.querySelector('a[href]');
          const pending = entry.querySelector('.ani-category-hierarchy__pending');
          const text = (link?.textContent || pending?.textContent || '').trim();
          if (!text) return;
          const option = document.createElement('option');
          if (link) {
            const path = normalizePath(link.getAttribute('href'));
            if (!path || seen.has(path)) return;
            seen.add(path);
            option.value = link.getAttribute('href');
            if (path === currentPath) {
              option.selected = true;
              hasCurrent = true;
            }
          } else {
            option.value = '';
            option.disabled = true;
            option.dataset.pendingCollection = pending?.dataset.collectionHandle || '';
          }
          option.textContent = text;
          select.appendChild(option);
        });
        if (select.options.length <= 1) return;
        if (hasCurrent) details.open = true;
        select.addEventListener('change', () => {
          if (select.value) window.location.assign(select.value);
        });
        content.appendChild(select);
        details.append(summary, content);
        host.appendChild(details);
      });
    });
  };

  const initCatalogNavigation = () => {
    document.querySelectorAll('[data-ani-catalog-nav]').forEach((nav) => {
      if (nav.dataset.aniCatalogReady === 'true') return;
      nav.dataset.aniCatalogReady = 'true';
      const currentHandle = (nav.dataset.currentHandle || '').trim();
      const itemSelect = nav.querySelector('[data-ani-catalog-item]');
      const itemPanels = [...nav.querySelectorAll('[data-ani-item-panel]')];

      const optionByHandle = (select, handle) => select ? [...select.options].find((option) => option.dataset.handle === handle) : undefined;
      const selectOption = (select, option) => {
        if (!select || !option) return false;
        option.selected = true;
        return true;
      };
      const showItemPanel = (itemHandle) => {
        itemPanels.forEach((panel) => { panel.hidden = panel.dataset.aniItemPanel !== itemHandle; });
      };
      const showSubcategory = (panel, categoryValue) => {
        panel?.querySelectorAll('[data-ani-subcategory-wrap]').forEach((wrap) => {
          wrap.hidden = wrap.dataset.aniSubcategoryWrap !== categoryValue;
        });
      };

      const dimensions = ['style', 'stone', 'finish', 'occasion'];
      const activeQuery = new URLSearchParams(window.location.search);
      const dimensionSelections = Object.fromEntries(dimensions.map((key) => [key, activeQuery.get(`ani_${key}`) || '']));
      const navigateCatalog = (url) => {
        const next = new URL(url, window.location.origin);
        dimensions.forEach((key) => {
          if (dimensionSelections[key]) next.searchParams.set(`ani_${key}`, dimensionSelections[key]);
          else next.searchParams.delete(`ani_${key}`);
        });
        next.searchParams.delete('page');
        window.location.assign(next.pathname + next.search);
      };
      nav.querySelectorAll('.ani-catalog-nav__select--navigate').forEach((select) => {
        const group = select.closest('[data-ani-catalog-group]');
        const dimension = group?.dataset.aniCatalogGroup;
        if (dimensions.includes(dimension)) {
          const activeHandle = dimensionSelections[dimension];
          if (activeHandle) {
            const chosen = optionByHandle(select, activeHandle);
            if (chosen) chosen.selected = true;
            group.setAttribute('open', '');
          }
          select.addEventListener('change', () => {
            dimensionSelections[dimension] = select.selectedOptions[0]?.dataset.handle || '';
            if (!dimensionSelections[dimension]) {
              const raw = select.value;
              dimensionSelections[dimension] = raw && !raw.endsWith('/all') ? raw.split('/').pop().split('?')[0] : '';
            }
            const base = window.location.pathname;
            navigateCatalog(base);
          });
        } else {
          select.addEventListener('change', () => { if (select.value) navigateCatalog(select.value); });
        }
      });

      itemPanels.forEach((panel) => {
        const categorySelect = panel.querySelector('[data-ani-local-category]');
        categorySelect?.addEventListener('change', () => {
          showSubcategory(panel, categorySelect.value);
          panel.querySelectorAll('[data-ani-subcategory-select]').forEach((subSelect) => { subSelect.selectedIndex = 0; });
        });
      });

      // Restore the current collection into the correct dimension and dependent dropdowns.
      let matched = false;
      if (currentHandle && currentHandle !== 'all') {
        const directDimensionSelects = [...nav.querySelectorAll('.ani-catalog-nav__group:not([data-ani-catalog-group="item"]) select')];
        directDimensionSelects.some((select) => {
          const option = optionByHandle(select, currentHandle);
          if (!option) return false;
          selectOption(select, option);
          select.closest('details')?.setAttribute('open', '');
          matched = true;
          return true;
        });

        if (!matched && itemSelect) {
          const directItem = optionByHandle(itemSelect, currentHandle);
          if (directItem) {
            selectOption(itemSelect, directItem);
            showItemPanel(currentHandle);
            matched = true;
          }
        }

        if (!matched) {
          itemPanels.some((panel) => {
            const subSelects = [...panel.querySelectorAll('[data-ani-subcategory-select], [data-ani-direct-subcategories]')];
            for (const select of subSelects) {
              const option = optionByHandle(select, currentHandle);
              if (!option) continue;
              const itemHandle = panel.dataset.aniItemPanel;
              selectOption(itemSelect, optionByHandle(itemSelect, itemHandle));
              showItemPanel(itemHandle);
              const wrap = select.closest('[data-ani-subcategory-wrap]');
              if (wrap) {
                const categorySelect = panel.querySelector('[data-ani-local-category]');
                if (categorySelect) categorySelect.value = wrap.dataset.aniSubcategoryWrap;
                showSubcategory(panel, wrap.dataset.aniSubcategoryWrap);
              }
              selectOption(select, option);
              nav.querySelector('[data-ani-catalog-group="item"]')?.setAttribute('open', '');
              matched = true;
              return true;
            }
            return false;
          });
        }
      }

      if (!matched && itemSelect) {
        itemSelect.selectedIndex = 0;
        showItemPanel('');
      }
    });
  };

  // Shopify collections are independent product sets. The storefront cannot rely on
  // navigating to a second collection to combine them. Resolve intersection by ID.
  const initCatalogIntersection = () => {
    document.querySelectorAll('.ani-ref-shop-page .ani-ref-shop-products').forEach((host) => {
      const params = new URLSearchParams(window.location.search);
      const selected = ['style', 'stone', 'finish', 'occasion']
        .map((dim) => ({ dim, handle: params.get(`ani_${dim}`) || '' }))
        .filter((entry) => /^[a-z0-9-]+$/.test(entry.handle));
      if (!selected.length || host.dataset.aniIntersectionReady) return;
      host.dataset.aniIntersectionReady = 'true';
      const grid = host.querySelector('.ani-ref-shop-grid');
      if (!grid) return;
      const heading = host.querySelector('.ani-ref-shop-products__header p');
      const oldPagination = host.querySelector('.ani-ref-pagination');
      grid.setAttribute('aria-busy', 'true');
      if (heading) heading.textContent = 'Finding matching jewellery…';
      const maxPages = 50;
      const getIds = async (handle) => {
        const ids = new Set();
        for (let page = 1; page <= maxPages; page++) {
          const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`;
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`Unable to load ${handle} collection (${response.status})`);
          const data = await response.json();
          if (!Array.isArray(data.products)) throw new Error('Unexpected Shopify collection response');
          data.products.forEach((item) => ids.add(String(item.id)));
          if (data.products.length < 250) return ids;
        }
        throw new Error('Collection contains more products than the intersection can safely check');
      };
      const fetchBaseCards = async () => {
        const all = [];
        const baseUrl = new URL(window.location.href);
        ['page', 'ani_style', 'ani_stone', 'ani_finish', 'ani_occasion'].forEach((key) => baseUrl.searchParams.delete(key));
        for (let page = 1; page <= maxPages; page++) {
          baseUrl.searchParams.set('page', String(page));
          const res = await fetch(baseUrl.pathname + baseUrl.search, { credentials: 'same-origin' });
          if (!res.ok) throw new Error('Could not load the selected base category');
          const html = await res.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const cards = [...parsed.querySelectorAll('.ani-ref-shop-page .ani-ref-shop-grid .ani-ref-product-card')];
          all.push(...cards);
          if (!parsed.querySelector('.ani-ref-shop-page .ani-ref-pagination__arrow[aria-label="Next page"]')) break;
        }
        return all;
      };
      Promise.all([Promise.all(selected.map(({ handle }) => getIds(handle))), fetchBaseCards()])
        .then(([sets, cards]) => {
          const matches = cards.filter((card) => {
            const id = card.dataset.aniProductId;
            return id && sets.every((ids) => ids.has(id));
          });
          const pageSize = 20;
          let page = 1;
          if (oldPagination) oldPagination.hidden = true;
          const controls = document.createElement('nav');
          controls.className = 'ani-ref-pagination ani-intersection-pagination';
          controls.setAttribute('aria-label', 'Filtered results pages');
          oldPagination?.after(controls);
          if (!oldPagination) grid.after(controls);
          const display = () => {
            const slice = matches.slice((page - 1) * pageSize, page * pageSize);
            grid.replaceChildren(...slice);
            if (!slice.length) grid.innerHTML = '<div class="ani-ref-empty-state"><h3>No matching products</h3><p>Try removing one of the selected Style, Stone, Finish or Occasion filters.</p></div>';
            if (heading) heading.textContent = `${matches.length} matching products`;
            controls.replaceChildren();
            const count = Math.ceil(matches.length / pageSize);
            if (count <= 1) return;
            const add = (label, dest, current = false) => {
              const button = document.createElement('button');
              button.type = 'button'; button.textContent = label;
              if (current) { button.classList.add('is-current'); button.setAttribute('aria-current', 'page'); }
              button.addEventListener('click', () => { page = dest; display(); host.scrollIntoView({ block: 'start', behavior: 'smooth' }); });
              controls.append(button);
            };
            if (page > 1) add('‹ Previous', page - 1);
            for (let i = 1; i <= count; i++) add(String(i), i, i === page);
            if (page < count) add('Next ›', page + 1);
          };
          display();
          initQuickAdd();
        })
        .catch((error) => {
          console.error('ANI combined collection filters:', error);
          grid.innerHTML = '<div class="ani-ref-empty-state"><h3>Could not apply combined filters</h3><p>Please retry, or clear one of the selected filters.</p></div>';
          if (heading) heading.textContent = 'Filter temporarily unavailable';
          oldPagination?.setAttribute('hidden', '');
        })
        .finally(() => grid.removeAttribute('aria-busy'));
    });
  };

  const initAutoNewArrivals = () => {
    document.querySelectorAll('[data-ani-auto-arrivals]').forEach((grid) => {
      if (grid.dataset.aniArrivalsInitialized === 'true') return;
      grid.dataset.aniArrivalsInitialized = 'true';
      const source = grid.dataset.sourceUrl || '/collections/all';
      const limit = Math.min(20, Math.max(1, Number.parseInt(grid.dataset.arrivalsLimit || '10', 10) || 10));
      const url = new URL(source, window.location.origin);
      // Shopify sorts the full collection BEFORE paginating, unlike a Liquid array sort.
      url.searchParams.set('sort_by', 'created-descending');
      ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
        const value = new URLSearchParams(window.location.search).get(key);
        if (value) url.searchParams.set(key, value);
      });
      grid.setAttribute('aria-busy', 'true');
      fetch(url.toString(), { method: 'GET', credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error(`Shopify collection returned ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cards = Array.from(doc.querySelectorAll('.ani-ref-shop-grid .ani-ref-product-card'));
          if (!cards.length) return; // Preserve the server-rendered fallback on a temporary failure.
          const next = document.createDocumentFragment();
          for (const card of cards.slice(0, limit)) {
            card.classList.add('ani-ref-product-card--compact');
            card.querySelector('.ani-ref-product-card__actions')?.remove();
            next.appendChild(card);
          }
          grid.replaceChildren(next);
          grid.dataset.aniArrivalsLoaded = 'true';
        })
        .catch(() => { // Keep original cards when Shopify is unavailable or temporarily blocked.
          delete grid.dataset.aniArrivalsInitialized;
        })
        .finally(() => grid.removeAttribute('aria-busy'));
    });
  };

  const init = () => {
    initDynamicCategoryGroups();
    initCategorySelectors();
    initCatalogNavigation();
    initCatalogIntersection();
    initHeader();
    initAutoNewArrivals();
    initSort();
    initFallbackCollectionFilters();
    initPriceFilters();
    initProduct();
    initQuickAdd();
    initCartPage();
    initTabs();
    initCarousels();
    initReviewSliders();
    initFaq();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', initDynamicCategoryGroups);
})();
